

























































































































import {Component, Vue} from "vue-property-decorator";
import AnimatedInput from "@/components/AnimatedInput.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import Browsercheck from "@/components/Browsercheck.vue";
import {Action, State} from "vuex-class";
import User from "@/models/User";
import UserListItem from "@/components/UserListItem.vue";
import featureFlags from "@/util/featureFlags";
import AdminAdapter from "@/adapters/admin";
import LdapConfig from "@/models/LdapConfig";


@Component({
  components: { AnimatedInput, LoadingButton, Browsercheck, UserListItem },
})
export default class Admin extends Vue {

  @State(state => state.admin.userList) userList!: User[];
  @State(state => state.admin.userListLoading) userListLoading!: boolean;
  @Action fetchUserList!: () => Promise<void>;
  @Action createUserInvitation!: (u: User) => Promise<User | null>;

  adminAdapter: AdminAdapter = new AdminAdapter();

  newUserName: string = "";
  newUserRole: string = "";
  roleOptions = [
    { value: "USER", text: 'Einfacher Benutzer' },
    { value: "ADMIN", text: 'Administrator' },
  ];

  isEnterprise: boolean = false;
  ldapEnabled: boolean = false;
  ldapConfig: LdapConfig = new LdapConfig();
  encryptionOptions = [
    { value: "LDAPS", text: 'LDAPS' },
    { value: "STARTTLS", text: 'StartTLS' },
    { value: "NONE", text: 'Unverschlüsselt' },
  ];

  async loadLdapConfig(): Promise<void> {
    try {
      const config: LdapConfig | null = await this.adminAdapter.getLdapConfig();
      if (config) {
        config.bindPassword = "";
        this.ldapConfig = config;
        this.ldapEnabled = config.enabled;
      }
    } catch (e) {
      this.$log.error("Could not load LDAP config", e);
    }
    try {
      const subscription = await this.adminAdapter.getSubscriptionDetails();
      this.isEnterprise = subscription && subscription.productId === "schicks_digital_enterprise";
    } catch (e) {
      this.isEnterprise = false;
    }
  }

  async testLdapConfig(): Promise<void> {
    try {
      await this.adminAdapter.testLdapConfig(this.ldapConfig);
      this.$toast.success("Verbindung zum Verzeichnisdienst erfolgreich.");
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        this.$toast.error("Verbindung fehlgeschlagen: " + e.response.data.message);
      } else {
        this.$toast.error("Verbindung zum Verzeichnisdienst fehlgeschlagen.");
      }
    }
  }

  async saveLdapConfig(): Promise<void> {
    try {
      const saved: LdapConfig = await this.adminAdapter.saveLdapConfig(this.ldapConfig);
      saved.bindPassword = "";
      this.ldapConfig = saved;
      this.ldapEnabled = saved.enabled;
      (this.$refs.ldapConfigModal as any).hide();
      this.$toast.success("Konfiguration gespeichert.");
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        this.$toast.error("Fehler: " + e.response.data.message);
      } else {
        this.$toast.error("Konfiguration konnte nicht gespeichert werden.");
      }
    }
  }


  async createNewUser(): Promise<void> {

    const newUser: User = new User();
    newUser.email = this.newUserName.toLowerCase();
    newUser.role = this.newUserRole;

    try {
      const createdUser: User | null = await this.createUserInvitation(newUser);
      if (createdUser) {
        this.adminAdapter.getInvitationToken(createdUser).then((invitationToken: string) => {
          const invitationLink = '' +
              featureFlags.frontendBaseUrl +
              "/redeem/" + encodeURIComponent(newUser.email) +
              "/" + encodeURIComponent(invitationToken);
          this.$swal({
            title: "Nutzer erstellt!",
            text: "Sende dem Nutzer folgenden Link zu: " + invitationLink,
            icon: "success",
            buttons: ["Gemacht, zurück", "Link kopieren"],
            dangerMode: false,
          }).then(result => {
            if (result) {
              const copyText: HTMLInputElement = document.createElement("input");
              document.body.appendChild(copyText);
              copyText.value = invitationLink;
              copyText.select();
              document.execCommand("copy");
              document.body.removeChild(copyText);
              this.$toast.success('Link wurde in die Zwischenablage kopiert.');
            }
          });
        }).catch(() => { // should not happen
          this.$toast.error("Ein Fehler trat beim Erstellen des Nutzers auf");
        });
      } else {
        this.$toast.error("Ein Fehler trat beim Erstellen des Nutzers auf");
      }
    } catch (e) {
      if (e.response && e.response.data && e.response.data.message) {
        this.$toast.error("Fehler: " + e.response.data.message);
      } else {
        this.$toast.error("Ein Fehler trat beim Erstellen des Nutzers auf");
      }
    }
  }

  mounted() {
    this.fetchUserList();
    this.loadLdapConfig();
  }
}
